import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Datatable from "../../components/datatable/Datatable";
import PaymentService from "../../services/payment";
import { useEffect, useState } from "react";
import columnsHeader from "./ColumnsHeaderData";
import Loader from "../../components/spinner/Spinner";
import Backdrop from "../../components/backdrop/Backdrop";
import Toast from "../../components/toast/Toast";
import PaymentHistoryModal from "./PaymentHistoryModal";
import { parsePaymentDate } from "../../utils/date";
import {
  buildPaymentCountByKey,
  getPaymentGroupKey,
} from "./paymentUtils";

const Payment = () => {
  const [rowData, setRowData] = useState([]);
  const [paymentCountByKey, setPaymentCountByKey] = useState({});
  const [rowDatahistoyMentors, setRowDataHistoyMentors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastStatus, setToastStatus] = useState("");
  const [backdrop, setBackdrop] = useState(false);
  const [isSidebar, setIsSidebar] = useState(null);
  const [open, setOpen] = useState(false);

  const getAllPayments = async () => {
    setLoading(true);
    try {
      const response = await PaymentService.fetchPayments();
      const payments = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

      const sortedPayments = [...payments].sort(
        (a, b) =>
          parsePaymentDate(b.payment_date) - parsePaymentDate(a.payment_date),
      );

      setPaymentCountByKey(buildPaymentCountByKey(sortedPayments));
      setRowData(sortedPayments);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("Error fetching payments:", err);
      setRowData([]);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete the record?")) return;
    setBackdrop(true);
    try {
      await PaymentService.deletePayment(id);
      setToastOpen(true);
      setToastMsg("Payment deleted successfully");
      setToastStatus("success");
      setBackdrop(false);
      setRowDataHistoyMentors((prev) => prev.filter((r) => r.id !== id));
      getAllPayments();
    } catch (err) {
      setToastOpen(true);
      setToastMsg("Something went wrong!");
      setToastStatus("error");
      console.log(err);
      setBackdrop(false);
    }
  };

  const onHistoy = (payment) => {
    const key = getPaymentGroupKey(payment);
    const filtered = rowData.filter((p) => getPaymentGroupKey(p) === key);
    const sorted = [...filtered].sort(
      (a, b) =>
        parsePaymentDate(b.payment_date) - parsePaymentDate(a.payment_date),
    );
    setRowDataHistoyMentors(sorted);
    setOpen(true);
  };
  useEffect(() => {
    getAllPayments();
  }, []);

  return (
    <div className="list">
      <Sidebar isSidebar={isSidebar} />
      <div className="listContainer">
        <Navbar isSidebar={isSidebar} setIsSidebar={setIsSidebar} />
        {loading ? (
          <Loader />
        ) : (
          <Datatable
            pageTitle={"Payments"}
            columnsData={columnsHeader.columnsData}
            actionColumn={columnsHeader.actionHeader(
              handleDelete,
              onHistoy,
              paymentCountByKey,
            )}
            rowData={rowData}
            defaultSortModel={[{ field: "payment_date", sort: "desc" }]}
          />
        )}
      </div>
      {open ? (
        <PaymentHistoryModal
          open={open}
          onClose={() => setOpen(false)}
          rowData={rowDatahistoyMentors}
          handleDelete={handleDelete}
        />
      ) : null}
      {toastOpen && (
        <Toast
          toastOpen={toastOpen}
          toastClose={() => setToastOpen(false)}
          toastMsg={toastMsg}
          toastStatus={toastStatus}
        />
      )}
      {backdrop && <Backdrop />}
    </div>
  );
};

export default Payment;
